export default {
    namespaced: true,
    state: {
        initialized: false,
        show: false,
        checked: false,
        text: '',
    },
    mutations: {
        INIT (state, config) {
            if (state.initialized) {
                return;
            }
            state.show = config.show;
            state.text = config.text;
            state.checked = config.selected;
            state.initialized = true
        },
        SET (state, checked) {
            state.checked = checked;
        },
    }
}